import useSWR from 'swr';
import { authenticatedFetcher } from '@/lib/swr';
import { PP_BASE_URL } from '@/lib/env';

type StudentSyncStatusResponse = {
  data?: {
    lastSyncedAt?: string | null;
  };
};

export function useGetStudentLastSync() {
  const baseUrl = PP_BASE_URL?.replace(/\/$/, '');
  const key = baseUrl ? `${baseUrl}/students/last-sync` : null;

  const {
    data: response,
    error,
    isLoading,
    mutate,
  } = useSWR<StudentSyncStatusResponse>(key, authenticatedFetcher, {
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 60000,
    shouldRetryOnError: (err: any) => err?.status !== 404,
  });

  const rawLastSyncedAt = response?.data?.lastSyncedAt;
  const lastSyncedAt = rawLastSyncedAt ? new Date(rawLastSyncedAt) : null;

  return {
    swrKey: key,
    lastSyncedAt,
    isLoading,
    error,
    mutate,
  };
}
